<script setup lang="ts">
import useLocale from '../../composables/useLocale';
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faList } from '@fortawesome/pro-solid-svg-icons';

library.add(faList);

type Emits = {
  (e: 'close'): void;
};
const emit = defineEmits<Emits>();

const { smAndDown } = useDisplay();
const { t } = useLocale();
</script>

<template>
  <v-card class="mx-auto" :class="{ 'width-screen-100': smAndDown }" min-width="320" color="surface">
    <v-card-title class="d-flex align-center">
      <FontAwesomeIcon class="mr-2 pl-2" icon="fa-solid fa-list" flip="horizontal" />
      <span>{{ t('book_player.label_navigation') }}</span>
      <v-spacer />
      <v-btn v-if="smAndDown" icon="mdi-close" variant="text" @click="emit('close')" color="on-surface"> </v-btn>
    </v-card-title>
    <div class="scrollable-content" :class="{ 'pa-0': smAndDown }">
      <slot />
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.v-card {
  padding-bottom: env(safe-area-inset-bottom, 0px);
  border-left: 10px solid rgb(var(--v-theme-brand-original)) !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.width-screen-100 {
  width: 100vw !important;
}

.scrollable-content {
  overflow-y: auto;
  max-height: calc(100dvh - 150px);
}
</style>
